'use client'

import { storeFutuExchange } from '@/shared/store/exchange'

import { useEffect } from 'react'
import { storeFutuWSMarket } from './useTickerStore'

const useInitTicker = () => {

  const { isConnected, Start24hrTicker, connect: marketConnect } = storeFutuWSMarket()
  const { BinanceExchangeInfo } = storeFutuExchange()

  useEffect(() => {
    if (isConnected) {
      Start24hrTicker()
    }
  }, [isConnected])

  useEffect(() => {
    BinanceExchangeInfo()
    marketConnect()
  }, [])

}

export default useInitTicker
